export default __webpack_public_path__ + "static/media/srcn188_side_2500x1875.9b3bc3c1.jpg";